import React, {Fragment, useState, useEffect} from 'react';
import {Loader} from './Loader'
import {Header} from './Header'
import {Footer} from './Footer'

export function Home(){

const [ data, enterData] = useState(true)

useEffect(()=>{
  setTimeout(()=>{
    enterData(false);
  }, 4000)
}, [])

    return (
      <Fragment>
        {data ? (
          <Loader />
        ) : (
          <Fragment>
           
            <div className="inner" style={{marginBottom: 100}}>
               <Header />
            <header>
              <img
                src="images/profile.jpg"
                style={{
                  borderRadius: 100,
                  display: "flex",
                  alignItems: "center",
                  margin: "auto",
                }}
                alt="Promise Shedrach"
                width={220}
              />
              <br />
              <h1 style={{ textAlign: "center" }}>
                Hi, <br /> I'm Promise Shedrach
                <br />
                <small> A Software Engineer</small>
              </h1>
            </header>
            <section className="tiles">
              <article className="style4">
                <span className="image">
                  <img src="images/pic01.jpg" alt="promise shedrach about me" />
                </span>
                <a href="/about-me">
                  <h2>About me</h2>
                  <div className="content">
                    <p>Know me in a glance.</p>
                  </div>
                </a>
              </article>
              <article className="style5">
                <span className="image">
                  <img
                    src="images/pic02.jpg"
                    alt="promise shedrach - my works"
                  />
                </span>
                <a href="/my-works">
                  <h2>My Works</h2>
                  <div className="content">
                    <p>Check out my past works and see what i do.</p>
                  </div>
                </a>
              </article>
              <article className="style7">
                <span className="image">
                  <img
                    src="images/pic03.jpg"
                    alt="promise shedrach - testimonial"
                  />
                </span>
                <a href="/testimonials">
                  <h2>Testimonial</h2>
                  <div className="content">
                    <p>
                      My clients are pleased with my work, check out what they
                      are saying.
                    </p>
                  </div>
                </a>
              </article>
              <article className="style3">
                <span className="image">
                  <img
                    src="images/pic01.jpg"
                    alt="promise shedrach - my resume"
                  />
                </span>
                <a
                  href="Promise Shedrach Resume.pdf"
                  download="Promise Shedrach Resume"
                >
                  <h2>my resume</h2>
                  <div className="content">
                    <button className="button primary">
                      <i className="fa fa-download" /> Download
                    </button>
                  </div>
                </a>
              </article>
            </section>
            </div>
            <Footer />
          </Fragment>
        )}
      </Fragment>
    );
} 